import { Box, Typography } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { RecommendationsGroup } from '../../types';
import favouriteCombinations from './favouriteCombinations';
import RateButtons from './RateButtons';
import RecommendationError from './RecommendationError';
import RecommendationResultItems from './RecommendationResultItems';
import RecommendationResultsSection from './RecommendationResultsSection';

interface Props {
  recommendations: RecommendationsGroup | null;
  error: boolean;
}

const RecommendationResults: FC<Props> = ({ recommendations, error }) => {
  const { t } = useTranslation();

  return (
    <Box>
      {!error && recommendations && (
        <>
          <RecommendationResultsSection
            title={t('aiRecommendations:results:header')}
          >
            <Typography
              data-testid="recommendation-results-description"
              fontSize={24}
              lineHeight="150%"
            >
              {recommendations.description}
            </Typography>
          </RecommendationResultsSection>

          <RecommendationResultsSection
            title={t('aiRecommendations:results:topMatch')}
          >
            <RecommendationResultItems
              recommendations={recommendations.recommendations}
            />
          </RecommendationResultsSection>

          <RateButtons feedback={recommendations.feedback} />
        </>
      )}
      {error && recommendations && (
        <>
          <RecommendationError
            error={t('aiRecommendations:resultsError:description')}
          />

          <RecommendationResultsSection
            title={t('aiRecommendations:results:previousResultsHeader')}
          >
            <Typography
              data-testid="recommendation-results-description"
              fontSize={24}
              lineHeight="150%"
            >
              {recommendations.description}
            </Typography>
          </RecommendationResultsSection>

          <RecommendationResultsSection
            title={t('aiRecommendations:results:topMatch')}
          >
            <RecommendationResultItems
              recommendations={recommendations.recommendations}
            />
          </RecommendationResultsSection>

          <RateButtons feedback={recommendations.feedback} />
        </>
      )}
      {error && !recommendations && (
        <>
          <RecommendationError
            error={t('aiRecommendations:resultsError:descriptionNoPrevResults')}
          />
          <RecommendationResultsSection
            title={t('aiRecommendations:results:favouritesHeader')}
          >
            <RecommendationResultItems
              recommendations={favouriteCombinations}
            />
          </RecommendationResultsSection>
        </>
      )}
    </Box>
  );
};

export default RecommendationResults;
